// FIXME client-learner\src\configs.tsの内容をこちらに移動する
export const PATH_NAME = {
  TOP: '/top',
  SIGNIN: '/signin',
};
